const customDataRoutes = [
  {
    path: '/custom-data',
    redirect: '/custom-data/filter',
    children: [
      {
        path: 'filter',
        name: 'CustomDataFilter',
        component: () => import('@/views/custom-data/custom-data-filter'),
        meta: {
          layout: 'DefaultLayout',
          title: '数据定制导出',
          inNavbar: true,
          pageType: 'public',
          cache: true,
          routeGroup: '大数据服务'
        }
      },
      {
        path: ':bizCode/buy',
        name: 'CustomDataBuy',
        component: () => import('@/views/custom-data/custom-data-buy'),
        meta: {
          layout: 'DefaultLayout',
          title: '数据定制导出订单支付'
        }
      },
      {
        path: ':bizCode/preview',
        name: 'CustomDataPreview',
        component: () => import('@/views/custom-data/custom-data-preview'),
        meta: { layout: 'DefaultLayout', title: '数据定制导出预览' }
      },
      {
        path: ':bizCode/result',
        name: 'CustomDataResult',
        component: () => import('@/views/custom-data/custom-data-result'),
        meta: {
          layout: 'DefaultLayout',
          title: '数据定制导出结果'
        }
      },
      {
        path: 'packets-buy',
        name: 'CustomDataPacketsBuy',
        component: () => import('@/views/custom-data/custom-data-packets-buy'),
        meta: { layout: 'DefaultLayout', title: '数据定制流量包充值' }
      }
    ]
  }
]

export default customDataRoutes
